var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('preloader',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoader),expression:"showLoader"}]}),_c(_vm.getLayoutName,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }